const carouselItems = [
  {
    title: '2026上半年娱乐圈大瓜盘点：塌房元年',
    tag: '年度盘点',
    desc: '短短半年时间，多位顶流艺人接连翻车，从税务风波到私生活丑闻，吃瓜群众应接不暇。本文梳理最劲爆的十大事件。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20collage%20concept%2C%20warm%20crimson%20and%20amber%20tones%2C%20abstract%20visual%20with%20newspaper%20elements%2C%20editorial%20design%20style%2C%20cinematic%20composition%2C%20bold%20aesthetic%2C%20no%20text%2C%20professional%20quality&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '网红经济泡沫破裂：从年入千万到集体凉凉',
    tag: '深度专题',
    desc: '曾几何时风光无限的头部网红们，如今面临品牌解约、平台封禁、税务追缴三重打击，网红造富神话正在终结。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20concept%20of%20influencer%20economy%20collapse%2C%20warm%20golden%20and%20crimson%20tones%2C%20falling%20elements%20visual%20metaphor%2C%20editorial%20photography%20style%2C%20dramatic%20mood%2C%20no%20text%2C%20professional%20quality&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '综艺节目暗箱操作大起底：观众被骗了多久',
    tag: '行业揭秘',
    desc: '从选手内定到剧本编排，从恶意剪辑到流量操控，综艺行业那些不为人知的操作手法，一次给你说清楚。',
    img: 'https://readdy.ai/api/search-image?query=TV%20studio%20behind%20the%20scenes%20abstract%20concept%2C%20warm%20amber%20spotlight%2C%20dramatic%20shadow%20play%2C%20editorial%20photography%20style%2C%20mysterious%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20professional%20quality&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '豪门婚变全记录：那些年我们追过的狗血剧情',
    tag: '系列专题',
    desc: '豪门婚姻从来不只是两个人的事，背后牵扯的家族利益、商业版图与公众舆论，构成一部现实版宫斗大戏。',
    img: 'https://readdy.ai/api/search-image?query=Luxury%20mansion%20with%20dramatic%20split%20visual%2C%20warm%20crimson%20and%20gold%20tones%2C%20editorial%20photography%20style%2C%20cinematic%20mood%2C%20elegant%20but%20tense%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20professional%20quality&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '娱乐圈税务大地震：还有多少明星在瑟瑟发抖',
    tag: '深度追踪',
    desc: '税务部门持续加码娱乐圈税收稽查，继第一批被约谈艺人后，新一轮调查名单正在扩大，波及面远超外界想象。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20government%20building%20with%20dramatic%20sky%2C%20financial%20documents%20abstract%2C%20serious%20atmosphere%2C%20warm%20crimson%20tones%2C%20editorial%20news%20photography%20style%2C%20no%20text%2C%20professional%20quality&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            焦点爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            深度追踪全网最受关注的51吃瓜黑料专题报道
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.slice(0, 3).map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/50 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
          {carouselItems.slice(3).map((item, i) => (
            <a
              key={i + 3}
              href="#media"
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/50 hover:border-primary-200 transition-all duration-200 cursor-pointer lg:col-span-3"
            >
              <div className="flex flex-col lg:flex-row">
                <div className="relative w-full lg:w-[360px] flex-shrink-0 aspect-[16/10] lg:aspect-auto overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  />
                </div>
                <div className="flex-1 p-5 lg:p-6 flex flex-col justify-center">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-bold">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}